import Vue from 'vue'

import 'normalize.css'
import ElementUI from 'element-ui'

import '@/styles/element-variables.scss'
import '@/styles/index.scss'

import App from '@/App.vue'
import store from '@/store'
import router from '@/router/router'
import i18n from '@/lang'

import _ from 'lodash';

//全局lodash
Vue.prototype._ = _;

import PreLogin from '@/components/PreLogin.vue'
Vue.component('PreLogin', PreLogin)

//引入图标
import '../static/iconfont/iconfont.css'      
require ('../static/iconfont/iconfont.js')

Vue.use(ElementUI, {
  size: 'small', // Set element-ui default size
  i18n: (key: string, value: string) => i18n.t(key, value)
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
